<template>
  <div class="lg:px-12 md:px-12 px-5 lg:pt-12 md:pt-12 py-8 landing">
    <div class="">
      <p class="fsize32 sm-fsize20 font-semibold text-primary text-center">
        EVENTS AROUND THE CORNER
      </p>

      <swiper class="swiper pad-5 mt-6" :options="swiperOptions">
        <swiper-slide v-for="data in campaignEvents" :key="data.title">
          <div
            class="shadow-xl bg-white rounded-b-lg cursor-pointer"
            @click="handleClick(data)"
          >
            <img
              :src="$imageURL + '/' + data.image"
              alt="img"
              class="w-full h-44 object-contain"
            />
            <div class="p-4">
              <div class="lg:mb-3 md:mb-3 mb-2">
                <p
                  class="text-black font-bold cursor-pointer fsize20-14px lineclamp-1 1h-28"
                >
                  {{ data.title }}
                </p>
              </div>
              <p class="text-sm">
                Date: {{ new Date(data.date).toLocaleDateString() }}
              </p>
              <p class="text-sm">Time: {{ data.time }}</p>
            </div>
            <!-- <p class="fsize14 font-semibold">Venue: {{data.}}</p> -->
          </div>
        </swiper-slide>

        <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
        <div class="swiper-button-next adminswiper" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      // ogData
      categoryId: null,
      selectedFilter: null,
      featuredEvent: [],
      upcomingEvent: [],
      pastEvent: [],
      pastEvent: [],
      allEvents: [],
      campaignEvents: [],
    };
  },
  methods: {
    async init() {
      // for getting all types of event
      await this.$store.dispatch("cms/getPageCategories");
      console.log(this.pageCategories, "888800000");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("events")) this.categoryId = element._id;
      });
      const campID = this.$route.params;
      // await this.$store.dispatch("cms/getTagsbyCategory", {
      //   categoryPage: this.categoryId,
      // });
      // await this.$store.dispatch("cms/getfilterbycategory", {
      //   categoryPage: this.categoryId,
      // });
      // this.filter1 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[0]._id
      // );
      // this.filter2 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[1]._id
      // );
      // this.filter3 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[2]._id
      // );
      let payload = {
        id: this.categoryId,
        selectedCampaigns: campID.id,
      };

      // if (this.selectedFilter == "Corporate") {
      //   Object.assign(payload, { onlyCorporateEvent: true });
      // }

      const data = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForEvent",
        payload
      );

      if (data.code === 200) {
        this.featuredEvent = this.categorywisepagesforevent.featured;
        this.upcomingEvent = this.categorywisepagesforevent.upcoming;
        this.pastEvent = this.categorywisepagesforevent.past;
        this.allEvents = [
          ...this.featuredEvent,
          ...this.upcomingEvent,
          ...this.pastEvent,
        ];
        this.campaignEvents = this.allEvents.filter(
          (data) => data.selectedCampaigns
        );
        // this.campaignEvents = this.allEvents.filter(
        //   (data) => data.isSelected == true
        // );
        console.log(this.campaignEvents, "888833333");
      }
      // }
    },
    handleClick(item) {
      // console.log(item, "URL");
      // console.log("navigate ....", ITEM, name);
      // this.$store.commit("ffc/SELECTED_CORPORATE_EVENT", ITEM);
      // this.$store.commit("ffc/SELECTED_EVENT_TYPE", this.type);
      // this.$router.push({ name: name, params: { eventName: ITEM.title } });
      // this.$router.push({ name: name });
      if (item.link) {
        console.log("self");
        window.open(item.link, "_self");
      } else {
        this.$router.push({ name: "events" });
      }
      // this.toggleNavbar();
    },
  },
  computed: {
    // ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),

    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
  },
  async mounted() {
    this.init();
  },
};
</script>
